import React, { useState } from "react"
import { isDefined, parseAmount } from "../../utils/utils"
import LineChart from "./LineChart";
import I18n from "i18n-js";
import IconTooltip from "./IconTooltip";

const Analytic = ({
    analytic,
    orientation
}) => {
    return (
        <React.Fragment>
            <h5 className="mb-0 font-weight--normal">
                {analytic.label.toUpperCase()}
            </h5>
            <h3 className={`my-0 d-flex ${orientation === 'right' ? 'justify-content-end' : 'justify-content-center justify-content-sm-start'} align-items-baseline`}>
                <b>{analytic.values[0]}</b>
                {analytic.values[1] &&
                    <div className="font-size-14px my-0">{analytic.values[1]}</div>
                }
            </h3>
        </React.Fragment>
    )

}


const SaleItemsChart = ({
    stats,
    renderStatistics,
    setRenderStatistics
}) => {

    const presentAnalytics = stats?.analytics?.length > 0

    return (
        <div className="d-flex flex-directions-column justify-content-between w-100 br-8px py-3 bg-aig-gradient-light">
            <div className="d-block">
                <div className="d-block d-sm-flex justify-content-between align-items-end">
                    <div className="text-aig-gradient mx-3">
                        <h2 className="my-0"><b>{stats.items_count} {stats.items_type}</b></h2>
                    </div>
                    {presentAnalytics &&
                        <div className="d-flex justify-content-end text-intense-blue mx-3">
                            <div>
                                <IconTooltip
                                    tooltipContent={I18n.t('js.indexSaleItems.charts.feesExcluded')}
                                    customComponentToRender={
                                        <Analytic
                                            analytic={stats.analytics[0]}
                                            orientation={'right'}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    }
                </div>



                {/* RENDERING DEL GRAFICO */}
                {stats.datasets &&
                    <div className="row d-flex align-items-center p-3">
                        <div className="col-12 col-md-4">
                            <LineChart
                                type={'doughnut'}
                                datasets={stats.datasets}
                                labels={stats.legend_labels}
                                options={{
                                    plugins: {
                                        tooltip: {
                                            enabled: false
                                        },
                                        legend: {
                                            display: false
                                        },
                                        datalabels: {
                                            display: false
                                        }
                                    }, cutout: '75%'
                                }}
                                maxHeight={'100px'}
                                id={`${stats.items_type}_sale_items_chart`}
                            />
                        </div>

                        <div className="col-12 col-md-8 d-flex px-0 flex-wrap justify-content-center d-md-block">
                            {stats.legend_labels.map((label, index) => {
                                return (
                                    <div className="row d-flex align-items-center m-auto px-2 px-md-0 py-1" style={{ color: stats.legend_colors[index] }} key={label}>
                                        <div className={`col-${isDefined(stats.legend_values) ? '6' : '12'} d-flex justify-content-center justify-content-md-start align-items-center px-0`}>
                                            <div className="h-15px w-15px mr-2">
                                                <div className="w-100 h-100perc br-50px" style={{ backgroundColor: stats.legend_colors[index] }} />
                                            </div>
                                            <h5 className="my-0 font-weight--normal">{label.toUpperCase()}</h5>
                                        </div>

                                        {isDefined(stats.legend_values) &&
                                            <div className="col-6 d-flex justify-content-center justify-content-md-end pb-1">
                                                <h3 className="my-0 d-flex align-items-baseline">
                                                    <b>{stats.legend_values[index][0]}</b>
                                                    <div className="font-size-14px my-0 text--white-space-no-wrap">{stats.legend_values[index][1]}</div>
                                                </h3>
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </div>



            <div className="d-block">
                {/* RENDERING DELLE STATISTICHE */}
                {presentAnalytics &&
                    <React.Fragment>
                        <div className="w-100 px-3 mb-1">
                            <div className="d-flex m-auto text-intense-blue"
                            >
                                <h5 className="d-flex my-0 cursor-pointer font-weight--normal"
                                    onClick={() => { setRenderStatistics(!renderStatistics) }}
                                >
                                    {I18n.t('js.indexSaleItems.charts.statistics').toUpperCase()}
                                    <img src={window.location.origin + `/images/icons/blue/arrow-${renderStatistics ? 'up' : 'down'}.svg`}
                                        alt="" width="10" height="10" className="ml-2"
                                    />
                                </h5>
                            </div>
                        </div>

                        {renderStatistics &&
                            <div className="row m-auto statistics-row text-intense-blue">
                                {stats.analytics.slice(1, stats.analytics.length).map(analytic => {
                                    return <div className="col-6 col-sm-4 d-block text-center text-sm-start pl-3 pr-1 py-2">
                                        <Analytic
                                            analytic={analytic}
                                        />
                                    </div>
                                })}
                            </div>
                        }
                    </React.Fragment>
                }
            </div>
        </div>
    )
}

export default SaleItemsChart

